import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type IntegrationStatus as SchemaIntegrationStatus } from '../schemas/IntegrationStatus';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const CancelExcelImportProductsContentType = '' as const;
export type CancelExcelImportProductsRequest = void;
export type CancelExcelImportProductsResponses = LinkCommonErrorResponses & {
    /**
     * @description Import canceled
     */
    '200': {
        'application/json': SchemaIntegrationStatus;
    };
};
export type CancelExcelImportProductsResponseSuccess = CancelExcelImportProductsResponses['200']['application/json'];
export type CancelExcelImportProductsSearchParams = undefined;
export type CancelExcelImportProductsPathParameters = {
    id: string;
};
export const CancelExcelImportProductsUrl = '/integrations/excel/import/products/{id}/cancel' as const;
export const CancelExcelImportProductsMethod = 'POST' as const;
export const getCancelExcelImportProductsUrl = (params: CancelExcelImportProductsPathParameters) =>
    CancelExcelImportProductsUrl.replace(/\{(\w+)\}/g, (_match, param: keyof CancelExcelImportProductsPathParameters) =>
        String(params[param])
    );
